import React, { Component } from 'react';
import {Paper, Grid, Typography, Button} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import DropDown from './DropDown';

export default class CycleAssessments extends Component {

    constructor(props) {
        super(props);
        this.reset_state = {
            assessments_view: false,
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            error: false,
            error_message: '',
            querying: true,
            matrix_array: [],
            show_dialogue: false,
            form_view: false,
            form_data: {},
            current_record: {},
            primary_button_enabled: false,
            primary_button_text: 'Add Assessment'
        }
        this.state = {  //Note: assessmemt_types & assessment_templates not reset
            assessments_view: false,
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            assessment_types: [],
            assessment_templates: [],
            error: false,
            error_message: '',
            querying: true,
            matrix_array: [],
            show_dialogue: false,
            form_view: false,
            form_data: {},
            current_record: {},
            primary_button_enabled: false,
            primary_button_text: 'Add Assessment'            
        };
        this.datasheetFieldSpecs = [
            // { field: 'id', headerName: 'Empl. #', width: 90, sortable:false},
            { field: 'assessment_template', headerName: 'Assessment', width: 300},
            { field: 'assessment_type', headerName: 'By', width: 130},
            { field: 'requires_nomination', headerName: 'Nomination Required?', width: 145, align: 'center', sortable:false},
        ]

        this.input_fieldSpecs = [

            {field: "assessment_template", headerName: "Assessment to Prescribe?", f_inputType:'dropdown', f_show:true, f_required:true},

            {field: "assessment_type", headerName: "Assessor?", f_inputType:'dropdown', f_show:true, f_required:true},

        ]
    }

    componentDidMount = () => {

        //async get assessment_types... - once off
        if (this.state.assessment_types.length===0){  
            Gserv.sendCommand('query_assessment_types',this.props.gwt)
            .then(ass_types => {
                // console.log('assessment_types :>> ', ass_types);
                if (ass_types.error){
                    console.log('error on return from Gserv (query_assessment_types) :>> ', ass_types);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (ass_types.Result!=="Success"&&ass_types.statusCode!==204){
                    console.log('error on return from Gserv (query_assessment_types) :>> ', ass_types);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState({assessment_types: ass_types.Records});
                }
            }); 
        }
 
        //async get assessment_templates... - once off
        if (this.state.assessment_templates.length===0){  
            Gserv.sendCommand('query_assessment_templates',this.props.gwt)
            .then(ass_templates => {
                // console.log('assessment_templates :>> ', ass_templates);
                if (ass_templates.error){
                    console.log('error on return from Gserv (query_assessment_templates) :>> ', ass_templates);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (ass_templates.Result!=="Success"&&ass_templates.statusCode!==204){
                    console.log('error on return from Gserv (query_assessment_templates) :>> ', ass_templates);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState({assessment_templates: ass_templates.Records});
                }
            }); 
        }

        Gserv.sendCommand('query_ass_cycle_matrix',this.props.gwt,{
            cycle_id: this.props.cycle.cycle_id
        })
        .then(reply=>{
            // console.log('query_ass_cycle_matrix reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_ass_cycle_matrix) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_ass_cycle_matrix) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                
                //clean formats for display
                if (reply.Records){
                let cycle_array = reply.Records;
                    for (var i=0;i<cycle_array.length;i++){
                        cycle_array[i].requires_nomination = cycle_array[i].requires_nomination? "YES" : "";
                    }
                }
                this.setState({querying:false, matrix_array:reply.Records?reply.Records : []});
            }
        });
    };

    editAssessments = (parms) => {
        console.log('edit assessments with parms :>> ', parms);
        this.setState({current_record:parms.row});

    }

    processForm = (e) => {
        e.preventDefault();
        // console.log('this.state.form_data :>> ', this.state.form_data);
        this.setState({writing:true, primary_button_enabled:false});
        //set state updating here...
        
        if (this.state.current_record.id){
            //this is an update

            // Gserv.sendCommand('update_cycle',this.props.gwt,{
            //     form_data : this.state.form_data,
            //     id : this.state.current_record.id
            // })
            // .then(reply => {
            //     // console.log('update reply :>> ', reply);
            //     if (reply.error){
            //         console.log('error on return from Gserv (update_cycle) :>> ', reply);
            //         this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            //     } else if (reply.statusCode===409) {
            //         console.log('error on return from Gserv (update_cycle) :>> ', reply);
            //         this.setState({error:true,error_message:"A cycle with this code or name already exists.",querying:false});
            //     } else if (reply.Result!=="Success") {
            //         console.log('error on return from Gserv (update_cycle) :>> ', reply);
            //         this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            //     } else {
            //         this.setState(this.reset_state);
            //         this.componentDidMount();
            //     }
            // });           

        } else {
            //this is a create
            Gserv.sendCommand('create_cycle_requirement',this.props.gwt,{
                form_data : this.state.form_data,
                cycle_id : this.props.cycle.cycle_id
            })
            .then(reply => {
                // console.log('create reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (create_cycle_requirement) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.statusCode===409){
                    console.log('error on return from Gserv (create_cycle_requirement) :>> ', reply);
                    this.setState({error:true,error_message:"An assessment like this is already prescribed for this cycle.",querying:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (create_cycle_requirement) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState(this.reset_state);
                    this.componentDidMount();
                }
            });
        }
    }

    handleFieldUpdate = (fieldObj) => {
        // console.log('called field update...');
        // console.log('child field update:',fieldObj);
        // console.log(this.state.current_record);
        // eslint-disable-next-line eqeqeq
        if (fieldObj.value==''){fieldObj.value=null}
        let myFormData = this.state.form_data;
        myFormData[fieldObj.field] = fieldObj.value;
        this.setState({form_data:myFormData});
        // console.log('current_record value : ',this.state.current_record[fieldObj.field]);
        // console.log('New value : ', fieldObj.value);
        // eslint-disable-next-line eqeqeq
        if(this.state.current_record[fieldObj.field]!=fieldObj.value){
            const truthyCurrentRec = this.state.current_record[fieldObj.field]? true : false;
            const truthyFieldObj = fieldObj.value ? true : false;
            //exclude nulls vs '' vs false etc.
            if (truthyCurrentRec||truthyFieldObj){
                // console.log('found update...');
                this.setState({primary_button_enabled:true});
            }
        } 
    }

    handleUpdate = (record) => {
        // N/A - no edit on this form
        // console.log('record for update :>> ', record);
        // this.setState({show_dialogue:true});
        //Hide just while testing modal...
        // this.setState({current_record:record.row,form_view:true,primary_button_enabled:false,primary_button_text:'Update Assessment cycle'});
    }

    handleDelete = (record) => {
        // console.log('record for delete :>> ', record);

        // this.setState({show_dialogue:true});
        //Hide just while testing modal...
        this.setState({deleting:true,querying:true});
        Gserv.sendCommand('delete_cycle_requirement',this.props.gwt,{
            cycle_requirement_id: record.id
        })
        .then(reply => {
            // console.log('delete reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (delete_cycle_requirement) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (delete_cycle_requirement) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState(this.reset_state);
                this.componentDidMount();
            }
        });

    }
    
    resetMe = () => {
        this.setState(this.reset_state);
        this.componentDidMount();
    }

    render() {
        return (
            <Grid
                container
                direction='column'
                justifyContent='center'
                alignContent='center'
                // style={{backgroundColor:'yellow'}}
            >
                
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        width:650
                    }}
                >
                    <Typography
                        style={{paddingTop:15}}
                    >
                       {this.props.cycle.cycle_code} ({this.props.cycle.cycle_name})
                    </Typography> 
    
                    <hr/>
                    <Typography
                        color='primary'
                        style={{paddingTop:15}}
                    >
                        Prescribe Assessments for this Cycle
                    </Typography>
                    <Grid
                        container
                        direction='row'
                        justifyContent='center'
                        alignContent='center'
                        style={{padding:15}}
                    >
                        {!this.state.form_view&&
                        <div>
                        <Button
                            variant='contained'
                            color='primary'
                            // type='submit'
                            onClick={()=>this.setState({form_view:true,primary_button_text:'Add Assessment',current_record:{}})}
                            disabled={this.state.form_view}
                        >
                            Add Assessment
                        </Button>
                        <Button 
                            // type='button'
                            variant='outlined'
                            disabled={this.state.writing}
                            onClick={()=>this.props.setParentState({assessments_view:false})}
                            style={{marginLeft:'15px'}}
                        >
                            Back
                        </Button>
                        </div>}
                    </Grid>
                </Paper>
                </Grid>
                <Grid item>
                    <Typography color='secondary' style={{Width:650,maxWidth:650, textAlign:'center'}}>{this.state.error_message}</Typography>
                    {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                </Grid>

                {/* {this.state.querying&&
                <Grid item>
                    <br/>
                    <Settings className='icn-spinner' /> Querying...
                </Grid>} */}

                {/* Datagrid goes here */}
                {!this.state.form_view&&
                <DatasheetView 
                    dataset={this.state.matrix_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={true}
                    edit={false}
                    handleDelete={this.handleDelete}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={8}
                />}

                {this.state.form_view&&
                <Paper
                    elevation={3}
                >
                    <form onSubmit={this.processForm}>
                        <br/>
                        <Grid 
                            container 
                            direction='column'
                            alignItems='baseline'
                            justifyContent='flex-start'
                            spacing={1}
                            style={{width:'70%', marginLeft:'30%' }}
                        >

                            <DropDown fieldMap={this.input_fieldSpecs[0]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} listArray={this.state.assessment_templates} disabled={this.state.writing}/>
                            
                            <DropDown fieldMap={this.input_fieldSpecs[1]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} listArray={this.state.assessment_types} disabled={this.state.writing}/>
                            <br/>
                        </Grid>
                        <Button 
                            color='primary'
                            variant='outlined'
                            disabled={!this.state.primary_button_enabled}
                            type='submit'
                            style={{marginTop:'20px', marginBottom: '20px'}}
                        >
                            {this.state.primary_button_text}
                        </Button>
                        <Button 
                            type='button'
                            variant='outlined'
                            disabled={this.state.writing}
                            onClick={()=>this.setState({form_view:false})}
                            style={{marginTop:'20px', marginBottom: '20px'}}
                        >
                            Cancel
                        </Button>
                    </form>
                </Paper>}

            </Grid>
        );
    }
    
}